import type { RepostNotification as RepostNotificationType } from '@/@types/notification'
import Avatar from '@/components/Avatar'
import { formatAsRelativeTime } from '@/utils/day'
import useNotificationClickHandler from '@/utils/hooks/useNotificationClickHandler'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import ScreenName from '../ScreenName'
import NotificationContainer from './NotificationContainer'
import NotificationReference from './NotificationReference'
import styles from './RepostNotification.module.css'

export interface RepostNotificationProps extends HTMLAttributes<HTMLDivElement> {
	data: RepostNotificationType
}

export default function RepostNotification({ data, className, ...props }: RepostNotificationProps) {
	const {
		actionItem: { users, usersCount, content },
		referenceItem,
		createdAt,
	} = data
	const { handleClick, isClickable } = useNotificationClickHandler(data)

	return (
		<NotificationContainer
			onClick={handleClick}
			isClickable={isClickable}
			className={clsx(styles.container, className)}
			{...props}
		>
			<Avatar data={users[0]} />

			<div className={styles.content}>
				<header className={styles.header}>
					<div className={styles.headerText}>
						<ScreenName data={users[0]} className={styles.screenName} />
						<span className={styles.secondaryText}>转发了你的动态</span>
					</div>
				</header>

				<main className={styles.main}>{content}</main>
				<footer className={styles.footer}>{formatAsRelativeTime(createdAt)}</footer>
			</div>

			<NotificationReference data={referenceItem} />
		</NotificationContainer>
	)
}
